<template>
  <div
    data-qa="analyses_lpu_cards_not_found"
    class="analyses-lpu-cards-not-found d-flex flex-column align-center justify-center text-center px-4 rounded-xl bg-gray-0 elevation-1"
  >
    <v-img
      :src="imageSrc"
      alt=""
      width="300"
      height="250"
      contain
      class="analyses-lpu-cards-not-found__image mb-6 flex-grow-0"
    />
    <div class="text-h5 text--text mb-4">
      Ничего не нашлось
    </div>
    <div class="text-body-1 text--text">
      Попробуйте изменить параметры поиска.
    </div>
  </div>
</template>

<script setup lang="ts">
import useContextStore from 'src/store/useContextStore'

const { context } = useContextStore()
const { src: staticPath } = context.global.static

const imageSrc = `${staticPath}_v1/pd/pictures/main-lists/nothing-found-by-filters.svg`
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';

.analyses-lpu-cards-not-found {
  padding-top: 72px;
  padding-bottom: 72px;
  border: 1px solid $ui-kit-bg-gray-60;

  &__image {
    max-width: 100%;
  }
}
</style>
